import { Navigate } from "react-router-dom";
import { useAuth } from "@clerk/clerk-react";
import { useCurrentUser } from "../lib/useCurrentUser";

export default function HomeRedirect() {
  const { isLoaded, isSignedIn } = useAuth();
  const { accessStatus, loading } = useCurrentUser();

  if (!isLoaded || (isSignedIn && loading)) {
    return (
      <div className="container-page py-24">
        <div className="surface mx-auto max-w-md p-6 text-center">
          <div className="mx-auto h-2 w-2 animate-pulse rounded-full bg-accent" />
          <p className="mt-3 text-sm text-slate-300">Loading…</p>
        </div>
      </div>
    );
  }

  if (!isSignedIn) return <Navigate to="/sign-in" replace />;
  if (accessStatus === "pending") return <Navigate to="/access-pending" replace />;
  return <Navigate to="/dashboard" replace />;
}
